import * as Yup from "yup"
import { isFieldRequired } from "./utils/isFieldRequired"

export const emailField: (isRequired: boolean) => Yup.Schema<string> = (
  isRequired,
) => isFieldRequired(Yup.string().email("Invalid email"), isRequired)
